<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import utils from '@/utils/utils'
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  created() {
    if (utils.getUrlPrem('meetingId')) {
      localStorage.setItem('meetingId', utils.getUrlPrem('meetingId'))
      this.$store.commit('SaveCurrentMeetingId', utils.getUrlPrem('meetingId'))
    }else{
      if(this.$route.name==='home'){
          localStorage.removeItem('meetingId')
          // this.$alert('当前没有meetingId', '',{
          //   showClose: false
          // })
          return
      }
    }
    this.getMeetingInfo()
    this.$store.commit('SaveDevice', window.innerWidth > 800)
    console.log(window.innerWidth)
  },
  computed: {
      meetingId() {
        return this.$store.state.meetingId
      }
  },
  methods: {
    GetQueryString(name) {
      let url = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let newUrl = window.location.search.substr(1).match(url)
      if (newUrl != null) {
        return unescape(newUrl[2])
      } else {
        return false
      }
    },
    async getMeetingInfo() {
      const res = await http.get(`${apis.getMeetingInfo}/${this.meetingId}`)
      console.log(res)
      this.meeting = res.result.meeting
      document.title=this.meeting.name
      localStorage.setItem('meeting',JSON.stringify(this.meeting))
    },
  },
  async mounted() {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      if (localStorage.getItem('openId')) {
        console.log('yoiu openid')
        return;
      }
      if (!this.GetQueryString('code')) {
        // this.$vux.toast.text('微信授权中……', 'default')
        let currentUrl = encodeURIComponent(window.location.href)
        let url = encodeURIComponent('http://web.nmep.com.cn')
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxffd775880c08139e&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
      } else {
        let code = this.GetQueryString('code')
        // 此处调用后端方法，通过 code 换取 openid
        console.log('code微信授权', code)
        let params = {
          code
        }
        const res = await http.get('http://web.nmep.com.cn:8080/renren-fast/app/h5pay/redirectpay', { params })
        console.log('获取openId结构', res)
        if (res.code == 0) {
          console.log('openId', res.openId)
          localStorage.setItem('openId', res.openId)
        }
      }
    }

    console.log(navigator.userAgent.toLowerCase().indexOf('micromessenger'), '是微信吗')
    // ticket.ticketPrice
    console.log('微信', wx)
    // wx.config({
    //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //   appId: '', // 必填，公众号的唯一标识
    //   timestamp: , // 必填，生成签名的时间戳
    //   nonceStr: '', // 必填，生成签名的随机串
    //   signature: '',// 必填，签名
    //   jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
    // });

  }
}
</script>
<style lang="stylus">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: #f1f1f1;
}
.el-picker-panel{
  // background-color red!important
  width 500px!important
}
.el-picker-panel__icon-btn {
   font-size 40px!important
}
.el-date-picker__header-label{
  font-size 30px!important
}

.el-date-table th{
   font-size 30px!important
}
.el-date-picker .el-picker-panel__content{
  width 450px!important
}

.el-date-table td span{
   font-size 30px!important
}

@media screen and (min-width: 800px) {

  .el-picker-panel{
    // background-color red!important
    width 400px!important
  }
  .el-picker-panel__icon-btn {
    font-size 16px!important
  }
  .el-date-picker__header-label{
    font-size 14px!important
  }

  .el-date-table th{
    font-size 14px!important
  }
  .el-date-picker .el-picker-panel__content{
    width 350px!important
  }

  .el-date-table td span{
    font-size 14px!important
  }

}
</style>
